import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCircle,
  faEdit,
  faLocation,
  faLocationDot,
  faPause,
  faPlay,
  faRotateLeft,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Button, Table } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { proxyAPI } from "../proxyAPI";
import LogicIcon from "../../assets/icons/library_logic.svg2";
import WeatherIcon from "../../assets/icons/monitoring/monitor_types/mon_weather.svg2";
import ApiIcon from "../../assets/icons/create_api_connection.svg2";
import MyPagination from "../Common/MyPagination";
import {
  useDeleteMonitorMutation,
  useGetMonitorsQuery,
  useLazyRunMonitorQuery,
} from "../store/slices/monitoringSlice";
import FullScreenLoadingIndicator from "../Common/FullScreenLoadingIndicator";
import DataImportModal from "../Common/DataImportModal/DataImportModal";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

const activeTable = [
  {
    icon: WeatherIcon,
    title: "Adverse Weather Monitor(London Area)",
    created: "10/04/2025",
    expires: "17/04/2025(7 Days)",
    status: "ACTIVE",
    logicConnected: true,
    urgency: "HIGH",
    editDelete: "",
  },
  {
    icon: WeatherIcon,
    title: "Adverse Weather Monitor(London Area)",
    created: "10/04/2025",
    expires: "17/04/2025(7 Days)",
    status: "ACTIVE",
    logicConnected: true,
    urgency: "HIGH",
    editDelete: "",
  },
  {
    icon: WeatherIcon,
    title: "Adverse Weather Monitor(London Area)",
    created: "10/04/2025",
    expires: "17/04/2025(7 Days)",
    status: "PAUSED",
    logicConnected: false,
    urgency: "LOW",
    editDelete: "",
  },
  {
    icon: WeatherIcon,
    title: "Wind Speed Monitor(Birmingham Area)",
    created: "10/04/2025",
    expires: "17/04/2025(7 Days)",
    status: "ACTIVE",
    logicConnected: true,
    urgency: "MED",
    editDelete: "",
  },
  {
    icon: WeatherIcon,
    title: "Rain Monitor(London Area)",
    created: "10/04/2025",
    expires: "17/04/2025(7 Days)",
    status: "ACTIVE",
    logicConnected: true,
    urgency: "HIGH",
    editDelete: "",
  },
];

function MonitoringListActiveTable({ filters }) {
  const confirmDialog = useConfirmDialog();
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(12);

  const {
    data: { monitors: alerts, total } = { monitors: [], total: 0 },
    refetch,
    isLoading,
    isFetching,
  } = useGetMonitorsQuery(
    { offset, limit, ...filters },
    { pollingInterval: 30000 }
  );
  const [deleteMonitor] = useDeleteMonitorMutation();
  const [runMonitor] = useLazyRunMonitorQuery();

  const handleDelete = async (uuid) => {
    if (
      !(await confirmDialog(
        "Are you sure?",
        "Are you sure you want to delete this monitor?"
      ))
    ) {
      return;
    }
    const { data: response } = await deleteMonitor({ uuid });

    if (response) {
      toast.success("Monitor deleted successfully.");
    } else {
      toast.error("Failed to delete the monitor. Please try again.");
    }
  };

  return (
    <div className="p-3 rounded-3 bg-white">
      <FullScreenLoadingIndicator loading={isLoading} />
      <Table responsive className="mt-3">
        <thead>
          <tr>
            <th>Monitor Type</th>
            <th>Priority</th>
            <th>Monitor Name:</th>
            <th>Reference</th>
            {/* <th>Created by</th> */}
            <th>Created at</th>
            <th>Monitor Status</th>
            <th>API Status</th>
            <th>Last Run</th>
            <th>Next Run</th>
            <th>Api Connection</th>
            <th className="text-end">
              <button
                title="Refresh"
                className="btn"
                onClick={() => {
                  if (offset === 0) {
                    refetch({ offset, limit });
                    return;
                  }
                  setOffset(0);
                }}
              >
                <FontAwesomeIcon icon={faRotateLeft} />
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {alerts?.map((item, i) => (
            <tr key={i}>
              <td>
                <div className="d-flex align-items-center gap-2">
                  {item.Kind === "weather" ? (
                    <WeatherIcon width={20} />
                  ) : (
                    <LogicIcon width={20} />
                  )}{" "}
                  {item.Kind.charAt(0).toUpperCase() + item.Kind.slice(1)}
                </div>
              </td>
              <td>
                {item.Priority === "high" && (
                  <div className="rounded-pill text-center px-2 p-1 border-0 fw-bold text-red bg-red-high">
                    HIGH
                  </div>
                )}
                {item.Priority === "low" && (
                  <div className="rounded-pill text-center px-2 p-1 border-0 fw-bold bg-green-low">
                    <span className="text-green-low">LOW</span>
                  </div>
                )}
                {item.Priority === "medium" && (
                  <div className="rounded-pill text-center px-2 p-1 border-0 fw-bold bg-yellow-med">
                    <span className="text-yellow-med">MEDIUM</span>
                  </div>
                )}
              </td>
              <td>{item.Label}</td>
              <td>{item.Reference}</td>
              <td>
                {item.CreatedAt === "0001-01-01T00:00:00Z" ||
                item.CreatedAt === ""
                  ? "-"
                  : new Date(item.CreatedAt).toLocaleString([], {
                      dateStyle: "short",

                      timeStyle: "short",
                    })}
              </td>
              <td className="text-nowrap">
                <div
                  className=" border-0 p-1 fw-bold text-nowrap"
                  // onClick={() => {
                  //   setOrder((p) => (p === "ACTIVE" ? "ACTIVE" : "PAUSE"));
                  // }}
                >
                  {item.Status === "active" ? (
                    <div className="bg-green-low rounded-pill d-inline-block px-3 p-1 fw-bold ">
                      <FontAwesomeIcon
                        size="sm"
                        className="text-success me-1"
                        icon={faCircle}
                      />
                      ACTIVE
                    </div>
                  ) : item.Status === "draft" ? (
                    <div className="bg-yellow-med rounded-pill d-inline-block px-3 p-1 fw-bold ">
                      <FontAwesomeIcon
                        size="sm"
                        className="text-warning me-1"
                        icon={faPause}
                      />
                      DRAFT
                    </div>
                  ) : (
                    <div className="bg-red-high rounded-pill d-inline-block px-3 p-1 fw-bold ">
                      <FontAwesomeIcon
                        size="sm"
                        className="text-danger me-1"
                        icon={faPause}
                      />
                      ARCHIVED
                    </div>
                  )}
                  {/* <span className="text-uppercase ms-2">{item.Status}</span> */}
                </div>
              </td>
              <td className="text-nowrap">
                {item.CurrentStatus && item.Kind === "ping" && (
                  <div className="d-flex align-items-center">
                    {item.CurrentStatus.Status === "ok" ? (
                      <div className="bg-green-low rounded-pill d-inline-block px-3 p-1 fw-bold ">
                        <FontAwesomeIcon
                          size="sm"
                          className="text-success"
                          icon={faCircle}
                        />
                        <span className="text-uppercase ms-2">ok</span>
                      </div>
                    ) : item.CurrentStatus.Status === "failing" ? (
                      <div className="bg-yellow-med rounded-pill d-inline-block px-3 p-1 fw-bold ">
                        <FontAwesomeIcon
                          size="sm"
                          className="text-warning"
                          icon={faCircle}
                        />
                        <span className="text-uppercase ms-2">failing</span>
                      </div>
                    ) : item.CurrentStatus.Status === "failed" ? (
                      <div className="bg-red-high rounded-pill d-inline-block px-3 p-1 fw-bold ">
                        <FontAwesomeIcon
                          size="sm"
                          className="text-danger"
                          icon={faCircle}
                        />
                        <span className="text-uppercase ms-2">failed</span>
                      </div>
                    ) : item.CurrentStatus.Status === "recovering" ? (
                      <div className="bg-yellow-med rounded-pill d-inline-block px-3 p-1 fw-bold ">
                        <FontAwesomeIcon
                          size="sm"
                          className="text-warning"
                          icon={faCircle}
                        />
                        <span className="text-uppercase ms-2">recovering</span>
                      </div>
                    ) : (
                      <div className="bg-secondary rounded-pill d-inline-block px-3 p-1 fw-bold ">
                        <FontAwesomeIcon
                          size="sm"
                          className="text-white"
                          icon={faCircle}
                        />
                        <span className="text-uppercase ms-2 text-white">
                          {item.CurrentStatus.Status}
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </td>
              <td>
                {item.CurrentStatus?.LastCheckAt
                  ? new Date(
                      item.CurrentStatus.LastCheckAt * 1000
                    ).toLocaleString()
                  : "-"}
              </td>
              <td>
                {item.CurrentStatus?.NextRun === "0001-01-01T00:00:00Z" ||
                item.CurrentStatus?.NextRun === ""
                  ? "N/A"
                  : new Date(item.CurrentStatus?.NextRun).toLocaleString([], {
                      dateStyle: "short",

                      timeStyle: "short",
                    })}
              </td>
              <td>
                {item.ApiConnectionUuid ? (
                  <DataImportModal
                    apiUuid={item.ApiConnectionUuid}
                    showButton={
                      <span className="btn bg-purple-gradient border-0">
                        <ApiIcon width={20} height={20} className="me-2" />{" "}
                        {item.ApiConnection?.Label}
                      </span>
                    }
                  />
                ) : (
                  "N/A"
                )}
              </td>
              <td className="text-end text-nowrap">
                {item.Kind === "weather" && (
                  <Link
                    to="/assets/maps"
                    className="btn bg-purple-gradient border-0 me-2 text-purple"
                    state={{
                      tab: "events",
                      mapFilters: {
                        Contacts: false,
                        Assets: false,
                        weatherFilters: {
                          isWeather: true,
                          showGrids: false,
                          StartAt: "",
                          EndAt: "",
                          range: -1,
                          period: "daily",
                          alertFilters: {
                            conditionIds:
                              item.WeatherAlert?.Conditions?.map((c) => c.ID) ||
                              [],
                            conditions: [],
                            search: "",
                            ruleID: item.WeatherAlert?.ID,
                          },
                        },
                        weatherForecastFilters: {
                          isForecast: false,
                        },
                        eventsFilters: {
                          isEvent: false,
                        },
                      },
                    }}
                  >
                    <FontAwesomeIcon icon={faLocationDot} />
                  </Link>
                )}
                <Link
                  to={`/monitoring/${item.Uuid}`}
                  className="btn bg-purple-gradient border-0 text-purple"
                >
                  <FontAwesomeIcon icon={faEdit} />
                </Link>
                <Button
                  className="bg-purple-gradient border-0 ms-2 text-purple"
                  onClick={() => handleDelete(item.Uuid)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
                <Button
                  className="bg-purple-gradient border-0 ms-2 text-purple"
                  onClick={async () => {
                    if (
                      !(await confirmDialog(
                        "Run Monitor",
                        `Are you sure you want to run this monitor? This  will trigger the connected projects to run immediately.`
                      ))
                    ) {
                      return;
                    }
                    runMonitor(item.Uuid);
                  }}
                >
                  <FontAwesomeIcon icon={faPlay} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <MyPagination
        total={total}
        onPaginate={(page, perPage) => {
          // loader(page, perPage);
          setOffset(page * perPage);
          setLimit(perPage);
        }}
      />
    </div>
  );
}

export default MonitoringListActiveTable;
